import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core';

export default makeStyles((theme) => ({
  errorMessage:{
    color:fade(theme.palette.text.primary,0.65),
    marginLeft:theme.spacing(0.4),
    marginTop:theme.spacing(1)
  },
}));
